import React, { useState } from 'react'
import { Card, CardContent, withStyles, Grid } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import CountryPage from '../index'
import style from './style'
import Edit from './Edit'
import Charts from './Charts'

const Channels = ({ country, classes, refetch }) => {
  const [edit, setEdit] = useState({
    mode: false,
    channels: {
      standard: [
        'Facebook',
        'Instagram',
        'Indeed',
        'LinkedIn',
        'Glassdoor',
        'Trustpilot',
        'Referred by a friend',
        'Other',
      ],
      custom: country.recruitmentChannels
        ? country.recruitmentChannels.customChannels
        : [],
      selected: country.recruitmentChannels
        ? country.recruitmentChannels.selectedChannels
        : [],
    },
  })

  return (
    <CountryPage
      country={country}
      breadcrumbs={[
        {
          label: 'Found us via',
        },
      ]}
    >
      <LayoutDashboard>
        {edit.mode ? (
          <Edit
            edit={edit}
            setEdit={setEdit}
            country={country}
            classes={classes}
            refetch={refetch}
          />
        ) : (
          <Grid container>
            <Grid item xs={3}>
              <Card className={classes.spacing}>
                <CardContent>
                  <Grid container>
                    <Grid item xs={8}>
                      <h3 className={classes.h3}>Active in {country.name}</h3>
                    </Grid>
                    <Grid item xs={4} className={classes.editButtonWrap}>
                      <button
                        type="button"
                        onClick={() =>
                          setEdit(edit => ({ ...edit, mode: !edit.mode }))
                        }
                      >
                        <EditIcon />
                      </button>
                    </Grid>
                  </Grid>
                  <ul className={classes.optionsList}>
                    {edit.channels.selected
                      .sort((a, b) =>
                        a.toLocaleLowerCase() < b.toLocaleLowerCase()
                          ? -1
                          : a.toLocaleLowerCase() > b.toLocaleLowerCase()
                          ? 1
                          : 0,
                      )
                      .map((value, index) => (
                        <li key={index} title={value}>
                          {value}
                        </li>
                      ))}
                  </ul>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
        <Charts classes={classes} country={country} channels={edit.channels} />
      </LayoutDashboard>
    </CountryPage>
  )
}

export default withStyles(style)(Channels)
